import {
  Home,
  Building2,
  Database,
  Landmark,
  CreditCard,
  FileCheck2,
  Layers,
  CalendarClock,
  UploadCloud,
  Cpu,
  Monitor,
  Settings,
  Activity,
  Banknote,
  Circle,
  ShieldCheck,
  Users,
  FileSpreadsheet,
  ExternalLink,
  Puzzle,
  ReceiptText,
  BadgeCheck,
  type LucideIconData
} from 'lucide-angular';

/**
 * Maps the icon names returned by the backend navigation API to Lucide icon data.
 * The backend stores icons as plain strings (e.g. "Database"); this is the single
 * place that binds those names to renderable icon objects.
 */
const ICONS: Record<string, LucideIconData> = {
  Home,
  Building2,
  Database,
  Landmark,
  CreditCard,
  FileCheck2,
  Layers,
  CalendarClock,
  UploadCloud,
  Cpu,
  Monitor,
  Settings,
  Activity,
  Banknote,
  ShieldCheck,
  Users,
  FileSpreadsheet,
  ExternalLink,
  Puzzle,
  ReceiptText,
  BadgeCheck
};

/** Resolves an icon name to its Lucide data, falling back to a neutral icon. */
export function resolveIcon(name: string | null | undefined): LucideIconData {
  if (name && ICONS[name]) {
    return ICONS[name];
  }
  return Circle;
}
